/**
 * eSIM Service
 * Handles all API calls related to eSIM status checking
 */

import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS, getProviderEndpoint } from '../config/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Check eSIM status by ICCID
 *
 * @param {string} iccid - The ICCID to check
 * @param {string} provider - auto | airhub | esimcard | travelroam | tgt
 * @returns {Promise}
 */
export const checkESIMStatus = async (iccid, provider = 'auto') => {
  try {
    const endpoint = getProviderEndpoint(provider);

    const response = await apiClient.post(endpoint, {
      iccid,
      provider,
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || {
        error: 'Network Error',
        details: error.message,
      },
    };
  }
};

export const checkHealth = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.HEALTH);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || { error: 'Network Error' },
    };
  }
};

export const getStats = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.STATS);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || { error: 'Network Error' },
    };
  }
};

export default {
  checkESIMStatus,
  checkHealth,
  getStats,
};
